import React, { useContext, useEffect, useState } from 'react';
import { merge } from 'react-merge';
import { useMediaQuery } from 'react-responsive';
import { Organization } from '../../models/Organization';
import { StyleContext } from '../../providers/StyleContextProvider';
import { LogoGridLoader } from '../Loaders/LogoGridLoader';
import { Logo } from './Logo';
import useErrorPage from '../../hooks/useErrorPage';
import Slider from 'react-slick';

interface Props {
    styles?: any;
    loadOrganizations(recordsCount: number): Promise<any>;
    recordsCount: number;
    rowsCount: number;
    isSlider?: boolean;
};

export const LogoGrid: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("logoGrid"));
    const [columnCount, setColumnCount] = useState<number>();
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const [loading, setLoading] = useState<boolean>(true);
    const [toErrorPage] = useErrorPage();
    const [organizations, setOrganizations] = useState<Organization[]>([]);
    
    useEffect(() => {
        // merge base styles with component specific styles                  
        let style = styleContext.getComponentStyle("logoGrid");
        let extendedStyles = merge(style, props.styles);        
        setStyles(extendedStyles);
        getLogoList();
    }, [isMobile]);

    async function getLogoList() {
        await props.loadOrganizations(props.recordsCount)
        .then((organizationList: Organization[]) => {
            setOrganizations(organizationList);
            setColumnCount(Math.ceil(organizationList.length / props.rowsCount));
            setLoading(false)
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }
    
    const sliderSettings = {
        infinite: true,
        autoplay: true,
        pauseOnHover: true,  
        speed: 5000,
        autoplaySpeed: 0,
        slidesToShow: isMobile ? 5 : 14,
        slidesToScroll: 1,
        cssEase: "linear",
        rows: props.rowsCount
    };
    
    return (
        <>
            {loading ? <LogoGridLoader style={styles} rowsCount={props.rowsCount} /> :
                <div style={styles}>
                    {props.isSlider ? 
                    <Slider {...sliderSettings}>
                        {organizations.map((organization, index) =>
                            <div key={index}>
                                <Logo style={styles.logo} organizationId={organization.organizationId} organizationName={organization.organizationName} hasLogo={organization.hasLogo} logoImageUrl={organization.logoImageUrl} />
                            </div>
                        )}
                    </Slider> :
                    <div style={{...styles.grid, ...{gridTemplateColumns: `repeat(${columnCount}, auto)`}}}>
                        {organizations.map((organization, index) =>
                            <div key={index} >
                                <Logo style={styles.logo} organizationId={organization.organizationId} organizationName={organization.organizationName} hasLogo={organization.hasLogo} logoImageUrl={organization.logoImageUrl} />
                            </div>
                        )}
                    </div>} 
                </div>
            }
        </>
    );
}